import { WHITE_LABEL_CONFIG } from './white_label';

export const cookieHTML = `
<div class="legal-modal">
    <p>Version 1.2 | Effective: February 27, 2026</p>
    
    <h3>Cookie Policy</h3>
    <p>At ${WHITE_LABEL_CONFIG.BRAND_NAME}, we are committed to protecting your privacy. This policy explains how we use cookies and similar technologies to provide our 11+ reporting service and measure the success of our marketing. We do not place non-essential cookies on your device unless you have provided your consent.</p>

    <h3>1. What are Cookies?</h3>
    <p>Cookies are small text files stored on your device. They help us remember your preferences, keep your payment session secure, and understand how people use our site.</p>

    <h3>2. How We Use Cookies</h3>
    <p>We categorize our cookies as follows:</p>
    <ul>
        <li><strong>Strictly Necessary:</strong> Required for the operation of the website and cannot be disabled via our cookie settings (e.g., processing secure payments via our payment provider).</li>
        <li><strong>Analytics:</strong> Used for statistical purposes to help us improve our service. We only use these cookies where you have provided consent.</li>
        <li><strong>Marketing:</strong> Used to measure the effectiveness of our ads on platforms like Google and Meta so we can reach more parents. These are only activated with your consent.</li>
    </ul>

    <h3>3. The Cookies We Use</h3>
    <table border="1" cellpadding="5" style="border-collapse: collapse; width: 100%;">
        <thead>
            <tr>
                <th>Provider</th>
                <th>Category</th>
                <th>Purpose</th>
                <th>Duration</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Stripe</td>
                <td>Strictly Necessary</td>
                <td>Secures transactions and prevents fraudulent payments.</td>
                <td>1 Year</td>
            </tr>
            <tr>
                <td>${WHITE_LABEL_CONFIG.BRAND_NAME}</td>
                <td>Strictly Necessary</td>
                <td>Remembers your consent choice and GPC status.</td>
                <td>6 Months</td>
            </tr>
            <tr>
                <td>Google Analytics</td>
                <td>Analytics</td>
                <td>Collects pseudonymous data on site usage (requires consent).</td>
                <td>2 Years</td>
            </tr>
            <tr>
                <td>Meta (Facebook)</td>
                <td>Marketing</td>
                <td>Measures social media ad effectiveness (requires consent).</td>
                <td>90 Days</td>
            </tr>
            <tr>
                <td>Google Ads</td>
                <td>Marketing</td>
                <td>Tracks search terms leading to a purchase (requires consent).</td>
                <td>90 Days</td>
            </tr>
        </tbody>
    </table>

    <h3>4. Global Privacy Control (GPC) & Your Preferences</h3>
    <p>We respect your right to privacy and support the Global Privacy Control (GPC) browser signal.</p>
    <ul>
        <li><strong>If GPC is Enabled:</strong> We respect this signal by defaulting to the rejection of all non-essential cookies (Analytics and Marketing). We may limit the cookie banner experience to avoid unnecessary interaction while honoring your browser's request.</li>
        <li><strong>Manual Choice Override:</strong> If you make a specific manual choice on our website (e.g., clicking "Accept All"), your manual choice takes precedence over the GPC signal for this specific site.</li>
        <li><strong>Changing Your Mind:</strong> You can update your preferences at any time via the "Cookie Settings" link in our footer.</li>
    </ul>

    <h3>5. How to Control Cookies</h3>
    <p><strong>Our Settings:</strong> Use the "Cookie Settings" link in our footer to adjust preferences. <br>
    <strong>Browser Settings:</strong> Most browsers allow you to block all cookies. Note: If you block all cookies, the payment checkout will not function, and you will be unable to purchase reports.</p>
</div>
`;
